











import { defineComponent, reactive } from '@vue/composition-api'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import AboutDialog from '@/components/AboutDialog.vue'

export default defineComponent({
  components: {
    AppHeader,
    AppFooter,
    AboutDialog
  },
  props: {},
  setup () {
    const viewState = reactive({
      isAboutShown: false
    })
    const showAbout = () => {
      viewState.isAboutShown = true
    }
    const hideAbout = () => {
      viewState.isAboutShown = false
    }
    return {
      viewState,
      showAbout,
      hideAbout
    }
  }
})
